<div *ngIf="Showdisplay1">
  <div class="menu">
    <span class="menu-heading"> Transferring: New/Unknown User</span>
    <!--<span class="close" (click)="closeTaskSelectionMenu()">X</span>-->
  </div>

  <div class="console">
    <div class="transfer-window">
      <p-tabView (onChange)="setSelectedTab($event)" class="transfer_tabs">
        <p-tabPanel
          *ngIf="AllowInternalTransfers"
          header="Internal"
          (click)="setSelectedTab('Internal')"
          (onChange)="setSelectedTab('External')"
        >
          <div style="margin-bottom: 1rem">
            <input
              type="text"
              [(ngModel)]="filterVal"
              class="search-box"
              placeholder="Search"
              (ngModelChange)="applyFilterByField($event)"
            />
            <img alt="" class="search-img inline-search-icon" src="{{ baseHref }}/assets/images/icon-search.svg" />
          </div>

          <table class="ptab-table table">
            <thead>
              <tr>
                <th scope="col" class="header">Agent</th>
                <th scope="col" class="header">Status</th>
                <th scope="col" class="header">Blind</th>
                <th scope="col" class="header">Announced</th>
                <th scope="col" class="header">Attended</th>
                <th scope="col" class="header">Voicemail</th>
                <th scope="col" class="header">Add</th>
              </tr>
            </thead>
            <tbody style="border-top: 0.063rem solid #97999b; font-size: medium">
              <tr *ngFor="let user of filteredinternalAgentdata">
                <td>{{ user.Name }}</td>
                <td>{{ user.Status }}</td>
                <td>
                  <button
                    class="main-btn"
                    [disabled]="getEnableDetail(user, 'blind')"
                    (click)="CallTransfer(user, 'blind')"
                    type="button"
                  >
                    Blind
                  </button>
                </td>
                <td>
                  <button
                    class="main-btn"
                    [disabled]="getEnableDetail(user, 'announced')"
                    (click)="CallTransfer(user, 'announced')"
                    type="submit"
                  >
                    Announced
                  </button>
                </td>
                <td>
                  <button
                    class="main-btn"
                    [disabled]="getEnableDetail(user, 'attended')"
                    (click)="CallTransfer(user, 'attended')"
                    type="submit"
                  >
                    Attended
                  </button>
                </td>
                <td>
                  <button class="main-btn" [disabled]="false" (click)="CallTransfer(user, 'voicemail')" type="submit">
                    Voicemail
                  </button>
                </td>
                <td>
                  <button
                    class="main-btn"
                    [disabled]="getEnableDetail(user, 'add')"
                    (click)="CallTransfer(user, 'add')"
                    type="submit"
                  >
                    Add
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </p-tabPanel>
        <p-tabPanel header="External" (onChange)="setSelectedTab('External')" (click)="setSelectedTab('External')">
          <table class="ptab-table table">
            <thead>
              <tr>
                <th scope="col" class="header">Name</th>
                <th scope="col" class="header">Number</th>
                <th scope="col" class="header">Blind</th>
                <th scope="col" class="header">Announced</th>
                <th scope="col" class="header">Attended</th>
                <th scope="col" class="header">Add</th>
              </tr>
            </thead>
            <tbody style="border-top: 0.063rem solid #97999b">
              <tr *ngFor="let user of externalUsers">
                <td>{{ user.Name }}</td>
                <td>{{ user.Phone }}</td>
                <td>
                  <button class="main-btn" (click)="CallTransfer(user, 'externalBlind')" type="button">Blind</button>
                </td>
                <td>
                  <button class="main-btn" (click)="CallTransfer(user, 'externalAnnounced')" type="submit">
                    Announced
                  </button>
                </td>
                <td>
                  <button class="main-btn" type="submit" (click)="CallTransfer(user, 'externalAttended')">
                    Attended
                  </button>
                </td>
                <td>
                  <button class="main-btn" type="submit" (click)="CallTransfer(user, 'externalAdd')">Add</button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col-3">
              <label class="country-code-label" for="country-code">Country Code: </label>
              <input
                [(ngModel)]="countryCode"
                type="text"
                class="search-box"
                (keyup.enter)="applyFilterByField($event)"
                style="width: 4rem"
              />
            </div>

            <div class="col-4">
              <label class="phone-no-label" for="phone-no">Phone Number: </label>
              <input
                [(ngModel)]="phoneNo"
                type="text"
                class="search-box"
                (keyup.enter)="applyFilterByField($event)"
                style="width: 9rem"
              />
            </div>

            <div class="col-5">
              <button class="main-btn" type="submit" (click)="CallTransfer(null, 'externalBlind')">Blind</button>
              <button class="main-btn mx-2" type="submit" (click)="CallTransfer(null, 'externalAnnounced')">
                Announced
              </button>
              <button class="main-btn" type="submit" (click)="CallTransfer(null, 'externalAttended')">Attended</button>
              <button class="main-btn ms-2" type="submit" (click)="CallTransfer(null, 'externalAdd')">Add</button>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Groups" (click)="setSelectedTab('Groups')" (onChange)="setSelectedTab('External')">
          <table class="ptab-table table">
            <thead>
              <tr>
                <th scope="col" class="header">Name</th>
                <th scope="col" class="header">Available</th>
                <th scope="col" class="header">Blind</th>
                <th scope="col" class="header">Announced</th>
                <th scope="col" class="header">Attended</th>
              </tr>
            </thead>
            <tbody style="border-top: 0.063rem solid #97999b">
              <tr *ngFor="let group of Groupdata">
                <td>{{ group.Name }}</td>
                <td>{{ group.AvailableAgents }}</td>
                <td>
                  <button
                    class="main-btn"
                    (click)="CallTransfer(group, 'groupBlind')"
                    title="Transfer immediately, without talking to the recipient first."
                    type="button"
                  >
                    Blind
                  </button>
                </td>
                <td>
                  <button
                    class="main-btn"
                    type="submit"
                    (click)="CallTransfer(group, 'groupAnnounced')"
                    title="Put the user on hold and call the recipient to alert them of the transfer."
                  >
                    Announced
                  </button>
                </td>
                <td>
                  <button
                    class="main-btn"
                    type="submit"
                    (click)="CallTransfer(group, 'groupAttended')"
                    title="Put the user on hold and start a conference call with the recipient. (Disabled pending future release)"
                  >
                    Attended
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </p-tabPanel>
      </p-tabView>
    </div>
    <div
      class=""
      style="
        background: #f7f7f5 0% 0% no-repeat padding-box;
        opacity: 1;
        border-radius: 0;
        display: block;
        padding: 0.625rem;
      "
    >
      <div class="row">
        <div class="col-4"></div>
        <div class="col text-center">
          <button
            class="main-btn extra_large red"
            type="submit"
            style="width: 12.5rem; border-radius: 1rem"
            (click)="closeTaskSelectionMenu()"
          >
            Cancel
          </button>
        </div>
        <div class="col-4"></div>
      </div>
    </div>
  </div>
</div>
<p-dialog [(visible)]="Showdisplay2" [modal]="true" [closable]="false" [style]="{ width: '30vw', right: '-4.625rem' }">
  <p>This will save any changes made.Would you like to continue?</p>
  <div style="text-align: end">
    <button class="main-btn" (click)="initiateCallTransfer()" type="submit">Continue</button>
    <button class="main-btn red ms-2" (click)="closeModal()" type="submit">Cancel</button>
  </div>
</p-dialog>

<div class="transferannounced">
  <p-dialog
    id="dialog"
    [(visible)]="Showdisplay3"
    [showHeader]="false"
    [breakpoints]="{ '60rem': '75vw' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [position]="'right'"
    [style]="{ width: '22%', 'top': '10%'}"
    #dialog
  >
    <div class="menu">
      <span class="menu-heading"> {{ title }}</span>
      <!--<span class="close" (click)="closeTaskSelectionMenu()">X</span>-->
    </div>
    <div class="console">
      <div class="row" style="margin: 0.313rem; gap: 0.6rem">
        <div class="col-4 at-lable-text">Recipient:</div>
        <div class="col at-lable-value">{{ step2Hdr1Text }}</div>
      </div>

      <div class="row" style="margin: 0.313rem">
        <div class="col-4 at-lable-text">On Call:</div>
        <div class="col at-lable-value">{{ step2Hdr2Text }}</div>
      </div>

      <hr class="at-separator" *ngIf="!ShowParticipantList" />
      <div class="at-lable-text-center">{{ Getdata('step2CallerText') }}</div>
      <div class="at-lable-text-center">{{ Getdata('step2ToggleState') }}</div>

      <div class="text-center">
        <button
          class="main-btn large"
          type="submit"
          [disabled]="!Getdata('step2ToggleBtn_enabled')"
          (click)="eStep2ToggleBtnClickHandler()"
          style="margin-right: 0.313rem; text-align: center"
        >
          Toggle Line
        </button>
      </div>

      <div class="col at-lable-value-center">
        <div class="bold">{{ Getdata('step2ToggleCaller') }}</div>
      </div>

      <div class="at-options">When you are ready,choose one of the following options</div>
      <div class="text-center">
        <button
          class="main-btn large"
          type="submit"
          [disabled]="!Getdata('step2CompleteBtn_enabled')"
          (click)="eStep2CompleteBtnClickHandler()"
        >
          {{ Getdata('step2CompleteBtn_label') }}
        </button>
      </div>
      <div class="text-center">
        <button
          class="main-btn large my-2"
          type="submit"
          *ngIf="Getdata('step2VoicemailBtn_visible')"
          [disabled]="!Getdata('step2VoicemailBtn_enabled')"
          (click)="sendVoiceMailClickHandler()"
        >
          Send to Voicemail
        </button>
      </div>
      <div class="text-center">
        <button class="main-btn red large mx-2" type="submit" (click)="eStep2ResumeBtnClickHandler()">
          {{ Getdata('step2ResumeBtn_label') }}
        </button>
      </div>
    </div>
  </p-dialog>
</div>

<div class="participantlist" *ngIf="ShowParticipantList && false">
  <div class="menu">
    <span class="menu-heading"> Conference Callers</span>
    <span class="close" (click)="closepartcipantlist()">X</span>
  </div>
  <div class="menu">
    <span class="menu-heading">{{ callersUserCountText }}</span>
    <span class="menu-heading">{{ callersInternalCountText }}</span>
    <span class="menu-heading">{{ callersExternalCountText }}</span>
  </div>
  <div class="middlecontent">
    <div class="row" style="margin: 0.313rem">
      <table class="ptab-table table">
        <thead>
          <tr></tr>
        </thead>
        <tbody style="border-top: 0.063rem solid #97999b">
          <tr *ngFor="let caller of getCallersList()">
            <td style="width: 100%">
              <div style="width: 100%; text-align: left">
                {{ caller.UserType === 'ThirdParty' ? 'External' : caller.CallerName }}
              </div>

              <div style="width: 100%; text-align: left">{{ formatPhoneNumber(caller.PhoneNumber, '') }}</div>
            </td>

            <td>
              <button
                *ngIf="!caller.ishold"
                class="bi bi-pause"
                style="-webkit-text-stroke: 0.063rem; border: none; height: 25px; width: 30px"
                (click)="HoldCall(caller)"
              ></button>
              <button
                *ngIf="caller.ishold"
                class="bi bi-play"
                style="border: none; height: 25px; width: 30px"
                (click)="HoldCall(caller)"
              ></button>
            </td>
            <td>
              <button
                [disabled]="caller.UserType === 'User'"
                (click)="DisconnectCall(caller)"
                style="border: none; height: 25px; width: 30px"
              >
                <img alt="" src="{{ baseHref }}/assets/images/icon-call-end.svg" alt="End Call" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="bottom">
    <span class="menu-heading"></span>
  </div>
</div>

<div class="accordion accordion-flush participantlist" *ngIf="ShowParticipantList">
  <div class="accordion-item" id="accordionOne" style="border-radius: 0.2rem">
    <div
      class="section-heading conference-heading"
      data-bs-toggle="collapse"
      data-bs-target="#collapseOne"
      aria-expanded="true"
      aria-controls="collapseOne"
    >
      Conference Callers
    </div>
    <div class="conference-menu">
      <span class="conf-count-text"
        >User
        <pre class="conf-pre"></pre></span
      ><span class="conf-count-value">{{ callersUserCountText }}</span>
      <pre class="conf-pre"></pre>
      <span class="conf-count-text"
        >Agent
        <pre class="conf-pre"></pre></span
      ><span class="conf-count-value">{{ callersInternalCountText }}</span>
      <pre class="conf-pre"></pre>
      <span class="conf-count-text"
        >External
        <pre class="conf-pre"></pre></span
      ><span class="conf-count-value">{{ callersExternalCountText }}</span>
    </div>
  </div>
  <div id="collapseOne" class="accordion-collapse collapse show accordian-padb" data-bs-parent="#accordionOne">
    <!-- <div class="accordion-body"> -->
    <div class="middlecontent">
      <!-- <div class="row" style="margin: 0.313rem"> -->
      <table class="ptab-table table">
        <thead>
          <tr></tr>
        </thead>
        <tbody>
          <tr *ngFor="let caller of getCallersList()">
            <td class="conf-td" style="width: 100%; padding: 0rem 0rem 0rem 0.6rem">
              <div class="conf-table-name">
                {{ caller.UserType === 'ThirdParty' ? 'External' : caller.CallerName }}
              </div>
              <div class="conf-table-PhNo">{{ formatPhoneNumber(caller.PhoneNumber, '') }}</div>
            </td>
            <td class="conf-td">
              <button *ngIf="!caller.ishold" class="bi bi-pause conf-btn-pause" (click)="HoldCall(caller)"></button>
              <button *ngIf="caller.ishold" class="bi bi-play conf-btn" (click)="HoldCall(caller)"></button>
            </td>
            <td class="conf-td">
              <button [disabled]="caller.UserType === 'User'" (click)="DisconnectCall(caller)" class="conf-btn">
                <img class="conf-btn-img" alt="" src="{{ baseHref }}/assets/images/icon-call-end.svg" alt="End Call" />
              </button>
            </td>
            <!-- <hr class="solid-headerDivider" style= /> -->
          </tr>
        </tbody>
      </table>
      <!-- </div> -->
    </div>
    <!-- </div> -->
  </div>
  <!-- </div> -->
</div>
